import { render, staticRenderFns } from "./PrSplit.vue?vue&type=template&id=15c40900&"
import script from "./PrSplit.vue?vue&type=script&lang=js&"
export * from "./PrSplit.vue?vue&type=script&lang=js&"
import style0 from "./PrSplit.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports